import axios from "@/api/axiosInstance";
import {
  FetchProductsHistoryReportParams,
  FetchProductsHistoryReportResponse,
} from "./types";

export const fetchProductsHistoryReport = async (
  params: FetchProductsHistoryReportParams = {},
  signal?: AbortSignal,
): Promise<FetchProductsHistoryReportResponse> => {
  const response = await axios.get<FetchProductsHistoryReportResponse>(
    "/api/private/reports/products-history",
    { params, signal },
  );
  return response.data;
};
